import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { Col } from 'react-bootstrap';
import { isUndefinedNull, notUndefinedNull, trimLowerCase } from '../../../helpers/shared';
import { defaultAux } from '../../../helpers/base';
import { Input } from '../../shared/Input';
import { paramsAdd, paramsEdit, speedTier } from '../../../constants/form';
import { fileStatus } from '../../../constants/files';
import { useTextLanguage } from '../../../hooks/useShared';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { BASE_FETCH_DOCUMENTS, BASE_SET_FETCHED_DOCUMENTS } from '../../../redux/types/base';
import { setLoader } from '../../../redux/actions/shared';

/**
 * Component aux input
 * @component
 * @param {Object} field
 * @returns
 */
export const AuxInput = ({ field }) => {
  const uniqueName = `${field.unique_name}__id__${field.id}`;
  const { description, languageText } = useTextLanguage();
  const { register, formState: { errors }, setValue } = useFormContext();
  const { action, lastTier } = useSelector(state => state.tier);
  const { data: personData } = useSelector(state => state?.personData);
  const { application } = useSelector(state => state?.user?.infoProductRequest)

  const { codeTier } = useParams();
  const dispatch = useDispatch();

  const [isDocumentSearch, setIsDocumentSearch] = useState(false)

  useEffect(() => {
    setTimeout(async () => {
      if (field?.default_value) {
        if (codeTier === fileStatus.rejected || codeTier === fileStatus.expired) {
          const storageData = (field?.storage_data_key) ? JSON.parse(
            field.storage_data_key) : null;
          if (isUndefinedNull(storageData) || storageData?.type === 'default') {
            defaultAux(field, setValue, uniqueName);
          }
        } else {
          if (action !== paramsEdit) {
            let res = await defaultAux(field, setValue, uniqueName)
            if (res){
              // Changing redux variable that will let documents know when to get their value
              dispatch({ type: BASE_FETCH_DOCUMENTS, payload: true });
              if (res.success) {
                const documentKeys = Object.keys(res.success).filter(key => res.success[key] === 'mandatory');
                if (isDocumentSearch) {
                  dispatch({ type: BASE_SET_FETCHED_DOCUMENTS, payload: documentKeys });
                }

              }
              // ? This dispatch below should be removed, and instead called when the document finish loading 
              const hasPrevValues = notUndefinedNull(personData?.first_name)

              // * Loader should HIDE, so that documents have time to load
              // * except there are previously values (check first name) or action=add
              if (!hasPrevValues || action === paramsAdd) dispatch(setLoader(false))
            } 
          } else {
            const storageData = (field?.storage_data_key) ? JSON.parse(
              field.storage_data_key) : null;
            if (isUndefinedNull(storageData) || storageData?.type === 'default') {
              defaultAux(field, setValue, uniqueName);
            } 
            if (application?.unique_name === 'update_data') {
              setTimeout(() => {
                dispatch(setLoader(false))
              }, 3000)
            }
          }
        }
      }

      // ? Ir order to make this effect play twice for the 'document__search' field
      if (field?.unique_name?.includes('document__search')) {
        setIsDocumentSearch(true)
      }
    }, 1000); 
  }, [field, action, setValue, uniqueName, isDocumentSearch]);

  return (
    <>
      {field && (
        <Col
          className={ field.col_size }
          data-module={ `module-${field.category?.field_category}` }
          data-name={ uniqueName }
          id={ `group_field_${field.id}` }
          key={ field.id }
          xs={12}
        >
          <Input
            autoComplete="off"
            className="w-100"
            field={ field }
            id={ trimLowerCase(field.id) }
            isRequiredInput={ field.required }
            label={ field[description] }
            message={ errors?.[uniqueName]?.message }
            name={ register(uniqueName).name }
            placeholder={ field?.[`placeholder${languageText}`] }
            register={ register(uniqueName) }
            setValue={ setValue }
            tooltipText={ field?.[`tooltip${languageText}`] }
            type="text"
          />
        </Col>
      )}
    </>
  );
};

AuxInput.propTypes = {
  field: PropTypes.object.isRequired
};